import { render } from "./HelpHotkeys.vue?vue&type=template&id=4e746691&ts=true"
import script from "./HelpHotkeys.vue?vue&type=script&lang=ts"
export * from "./HelpHotkeys.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__